import React from "react";
import { gql } from "@apollo/client";
import { FormattedDate } from "react-intl";
import { Link } from "react-router-dom";

import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  CloudDownload as DownloadIcon,
  CurrencyUsdOff as CreateCreditNoteIcon,
  Cart as OrderIcon,
  InformationOutline as InfoIcon,
} from "mdi-material-ui";

import CreateCreditNote from "./CreateCreditNote";
import UpdatePaymentInfos from "./UpdatePaymentInfos";

export default function InvoicesListItem({ invoice }) {
  return (
    <ListItem dense divider>
      <ListItemText
        primary={
          <>
            <strong>{invoice.reference}</strong>
            {" - "}
            {invoice.billingAddress?.fullName}
          </>
        }
        secondary={
          <FormattedDate
            value={invoice.createdAt}
            year="numeric"
            month="long"
            day="2-digit"
            hour="2-digit"
            minute="2-digit"
          />
        }
      />

      <ListItemSecondaryAction>
        <UpdatePaymentInfos invoice={invoice}>
          {({ open }) => (
            <Tooltip
              placement="left"
              title="Mettre à jour les informations de paiement"
            >
              <IconButton size="small" onClick={open}>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          )}
        </UpdatePaymentInfos>

        {invoice.order && (
          <Tooltip placement="left" title="Voir la commande">
            <IconButton
              size="small"
              component={Link}
              to={`/orders/${invoice.order.id}`}
            >
              <OrderIcon />
            </IconButton>
          </Tooltip>
        )}

        {invoice.creditNotes?.map((creditNote) => (
          <Tooltip
            key={creditNote.id}
            placement="left"
            title={
              <span>
                {creditNote.file.name}
                <br />
                Généré le{" "}
                <FormattedDate
                  value={creditNote.createdAt}
                  year="numeric"
                  month="long"
                  day="2-digit"
                  hour="2-digit"
                  minute="2-digit"
                />
              </span>
            }
          >
            <IconButton
              size="small"
              component="a"
              href={creditNote.file.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        ))}

        <CreateCreditNote invoice={invoice}>
          {({ open }) => (
            <Tooltip placement="left" title="Créer un avoir pour cette facture">
              <IconButton size="small" onClick={open}>
                <CreateCreditNoteIcon />
              </IconButton>
            </Tooltip>
          )}
        </CreateCreditNote>

        <Tooltip placement="left" title="Télécharger la facture">
          <IconButton
            size="small"
            component="a"
            href={invoice.file?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

InvoicesListItem.fragments = {
  invoice: gql`
    fragment InvoicesListItem_invoice on Invoice {
      id
      createdAt
      reference

      billingAddress {
        fullName
      }

      file {
        id
        url
      }

      order {
        id
      }

      creditNotes {
        id
        reference
        createdAt
        file {
          id
          name
          url
        }
      }

      ...Billing_CreateCreditNote_invoice
      ...Billing_UpdatePaymentInfos_Invoice
    }

    ${CreateCreditNote.fragments.invoice}
    ${UpdatePaymentInfos.fragments.invoice}
  `,
};
